// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__YkT8g","actionsCol":"EnrolledClinics_actionsCol__3iogw"};